export const DataTable1 = [
  {
    id: '1',
    name1: 'input1',
    input1: '',
    placeInput1: '8',
    name2: 'input2',
    input2: '',
    placeInput2: '34',
    name3: 'input3',
    input3: '',
    placeInput3: '75',
    name4: 'input4',
    input4: '',
    placeInput4: '7.15',
    name5: 'input5',
    input5: '',
    placeInput5: '79',
    name6: 'input6',
    input6: '',
    placeInput6: '20',
    name7: 'input7',
    input7: '',
    name8: 'input8',
    placeInput7: '2.36',
    input8: '',
    placeInput8: '7.82',
  },
  {
    id: '2',
    name1: 'input1',
    input1: '',
    placeInput1: '5',
    name2: 'input2',
    input2: '',
    placeInput2: '23',
    name3: 'input3',
    input3: '',
    placeInput3: '45',
    name4: 'input4',
    input4: '',
    placeInput4: '6.36',
    name5: 'input5',
    input5: '',
    placeInput5: '76',
    name6: 'input6',
    input6: '',
    placeInput6: '23',
    name7: 'input7',
    input7: '',
    placeInput7: '3.64',
    name8: 'input8',
    input8: '',
    placeInput8: '1.65',
  },
  {
    id: '3',
    name1: 'input1',
    input1: '',
    placeInput1: '20',
    name2: 'input2',
    input2: '',
    placeInput2: '63',
    name3: 'input3',
    input3: '',
    placeInput3: '56',
    name4: 'input4',
    input4: '',
    placeInput4: '7.34',
    name5: 'input5',
    input5: '',
    placeInput5: '84',
    name6: 'input6',
    input6: '',
    placeInput6: '27',
    name7: 'input7',
    input7: '',
    placeInput7: '6.26',
    name8: 'input8',
    input8: '',
    placeInput8: '4.18',
  },
  {
    id: '4',
    name1: 'input1',
    input1: '',
    placeInput1: '15',
    name2: 'input2',
    input2: '',
    placeInput2: '52',
    name3: 'input3',
    input3: '',
    placeInput3: '28',
    name4: 'input4',
    input4: '',
    placeInput4: '3.72',
    name5: 'input5',
    input5: '',
    placeInput5: '78',
    name6: 'input6',
    input6: '',
    placeInput6: '18',
    name7: 'input7',
    input7: '',
    placeInput7: '4.67',
    name8: 'input8',
    input8: '',
    placeInput8: '5.67',
  },
  {
    id: '5',
    name1: 'input1',
    input1: '',
    placeInput1: '30',
    name2: 'input2',
    input2: '',
    placeInput2: '53',
    name3: 'input3',
    input3: '',
    placeInput3: '72',
    name4: 'input4',
    input4: '',
    placeInput4: '4.71',
    name5: 'input5',
    input5: '',
    placeInput5: '91',
    name6: 'input6',
    input6: '',
    placeInput6: '15',
    name7: 'input7',
    input7: '',
    placeInput7: '5.25',
    name8: 'input8',
    input8: '',
    placeInput8: '3.58',
  },
];

export const DataTable2 = [
  {
    id: '1',
    name11: 'input11',
    input11: '',
    placeInput11: '3.3',
    name22: 'input22',
    input22: '',
    placeInput22: '5.6',
    name33: 'input33',
    input33: '',
    placeInput33: '7.9',
    name44: 'input4',
    input44: '',
    placeInput44: '7.1',
    name55: 'input55',
    input55: '',
    placeInput55: '1.78',
  },
  {
    id: '2',
    name11: 'input11',
    input11: '',
    placeInput11: '8.5',
    name22: 'input22',
    input22: '',
    placeInput22: '3.4',
    name33: 'input33',
    input33: '',
    placeInput33: '7.5',
    name44: 'input4',
    input44: '',
    placeInput44: '7.2',
    name55: 'input55',
    input55: '',
    placeInput55: '9.23',
  },
  {
    id: '3',
    name11: 'input11',
    input11: '',
    placeInput11: '4.1',
    name22: 'input22',
    input22: '',
    placeInput22: '3.4',
    name33: 'input33',
    input33: '',
    placeInput33: '7.5',
    name44: 'input4',
    input44: '',
    placeInput44: '4.8',
    name55: 'input55',
    input55: '',
    placeInput55: '8.24',
  },
  {
    id: '4',
    name11: 'input11',
    input11: '',
    placeInput11: '7.3',
    name22: 'input22',
    input22: '',
    placeInput22: '8.2',
    name33: 'input33',
    input33: '',
    placeInput33: '8.5',
    name44: 'input4',
    input44: '',
    placeInput44: '5.9',
    name55: 'input55',
    input55: '',
    placeInput55: '7.95',
  },
  {
    id: '5',
    name11: 'input11',
    input11: '',
    placeInput11: '3.9',
    name22: 'input22',
    input22: '',
    placeInput22: '3.4',
    name33: 'input33',
    input33: '',
    placeInput33: '3.5',
    name44: 'input4',
    input44: '',
    placeInput44: '5.5',
    name55: 'input55',
    input55: '',
    placeInput55: '4.96',
  },
];

export const DataTable3 = [
  {
    id: '1',
    name11: 'input11',
    input11: '',
    placeInput11: '40',
    name22: 'input22',
    input22: '',
    placeInput22: '50',
    name33: 'input33',
    input33: '',
    placeInput33: 'White',
    name44: 'input4',
    input44: '',
    placeInput44: '7',
    name55: 'input55',
    input55: '',
    placeInput55: '17',
    name66: 'input66',
    input66: '',
    placeInput66: '28',
  },
  {
    id: '2',
    name11: 'input11',
    input11: '',
    placeInput11: '100',
    name22: 'input22',
    input22: '',
    placeInput22: '100',
    name33: 'input33',
    input33: '',
    placeInput33: 'Red',
    name44: 'input4',
    input44: '',
    placeInput44: '5',
    name55: 'input55',
    input55: '',
    placeInput55: '23',
    name66: 'input66',
    input66: '',
    placeInput66: '15',
  },
  {
    id: '3',
    name11: 'input11',
    input11: '',
    placeInput11: '40',
    name22: 'input22',
    input22: '',
    placeInput22: '100',
    name33: 'input33',
    input33: '',
    placeInput33: 'Blue',
    name44: 'input4',
    input44: '',
    placeInput44: '4',
    name55: 'input55',
    input55: '',
    placeInput55: '24',
    name66: 'input66',
    input66: '',
    placeInput66: '24',
  },
  {
    id: '4',
    name11: 'input11',
    input11: '',
    placeInput11: '100',
    name22: 'input22',
    input22: '',
    placeInput22: '50',
    name33: 'input33',
    input33: '',
    placeInput33: 'Green',
    name44: 'input4',
    input44: '',
    placeInput44: '5',
    name55: 'input55',
    input55: '',
    placeInput55: '35',
    name66: 'input66',
    input66: '',
    placeInput66: '29',
  },
  {
    id: '5',
    name11: 'input11',
    input11: '',
    placeInput11: '40',
    name22: 'input22',
    input22: '',
    placeInput22: '50',
    name33: 'input33',
    input33: '',
    placeInput33: 'White',
    name44: 'input4',
    input44: '',
    placeInput44: '5',
    name55: 'input55',
    input55: '',
    placeInput55: '49',
    name66: 'input66',
    input66: '',
    placeInput66: '31',
  },
];
